import React from "react";
import { CTAButton } from "../common/CTA";
import HeroAnimation from "./HeroAnimation";
import { useScreen } from "../../context/ScreenContext";
import bgImage from "../../assets/Common/aurora.svg";
import experienceStars from "../../assets/Home/experience-stars.svg";
import AnimatedButton from "../common/AnimatedButton";
import "./HeroSection.css";

export default function HeroSection({ handleScroll }) {
  const { isMobile } = useScreen();
  return (
    <div className="relative w-full md:h-[calc(90vh-64px)] overflow-hidden pb-4">
      {/* Background image */}
      <div
        className="md:hidden absolute inset-0 bg-cover bg-no-repeat z-0"
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>

      {/* Gradient overlay */}
      <div className="absolute inset-0 z-10 bg-[linear-gradient(to_bottom,_rgba(40,110,207,0.6)_0%,_rgba(97,158,236,0.5)_25%,_rgba(174,207,251,0.5)_55%,_rgba(255,255,255,0)_85%)]"></div>

      {/* Content */}
      <div className="relative z-20 flex justify-center w-full h-full">
        {!isMobile && <HeroAnimation />}
        <div
          className={`flex ${
            isMobile ? "w-full" : "w-[762px]"
          } flex-col items-center gap-[36px] px-[20px]`}
        >
          <div className="flex flex-col mt-[5vh] md:mt-[15vh] items-center gap-[16px] self-stretch">
            {isMobile ? (
              <h1 className="text-center font-montserrat text-[32px] font-semibold leading-[43px] bg-gradient-to-r from-[#000000] to-[#0060C7] bg-clip-text text-transparent w-full">
                The Future of Enterprise Runs on AI. We Engineer It.
              </h1>
            ) : (
              <div className="relative font-montserrat bg-gradient-to-r from-black to-[#0060C7] bg-clip-text text-transparent text-center text-[50px] not-italic font-semibold leading-[66.55px]">
                The Future of Enterprise Runs on AI. We{" "}
                <span className="rounded-l-[12px] bg-[rgba(115,102,254,0.25)] text-black px-[6px]">
                  Engineer It.
                </span>
                <div className="absolute top-[43px] right-[-150px] rounded-[8px_8px_8px_0px] bg-[#7366FE] flex w-[156px] h-[26px] px-[6px] py-[3px] justify-center items-center">
                  <div className="relative text-white text-center font-montserrat text-[16px] font-medium leading-[24px] flex w-[144px] h-[20px] flex-col justify-center flex-shrink-0">
                    <span>Full-Stack GenAI</span>
                    <div className="absolute w-[4px] h-[71px] bg-[#7366FE] top-[13px] left-[-6px]"></div>
                  </div>
                </div>
              </div>
            )}
            <div className="flex w-full md:p-[12px_27px_8px_28px] justify-center items-center">
              <p className="w-full md:w-[672px] flex-shrink-0 text-[#444444] text-center font-montserrat text-[16px] not-italic font-normal leading-[25.6px]">
                A decade of deep tech expertise applied to building
                enterprise-ready AI products and agentic systems that perform in
                the real world.
              </p>
            </div>
          </div>
          <div className="flex w-full items-center justify-center gap-[24px] md:gap-[38px] z-10">
            {/* <CTAButton to={"https://ai.think41.com/login"}>
              <img
                src={experienceStars}
                alt="stars-icon"
                className={`mr-[2px] md:w-auto w-[14px]`}
              />
              Experience Center
            </CTAButton> */}

            <AnimatedButton
              className={
                "fancy relative h-[36px] md:h-[50px] w-[180px] md:w-[230px]"
              }
            >
              <span className="z-10 flex gap-1 sm:gap-2 items-center justify-center text-white font-montserrat font-medium md:px-0 px-[10px] text-[12px] md:text-[16px]">
                <img
                  src={experienceStars}
                  alt="stars"
                  className="animate-pulse-scale h-4 w-4 md:h-5 md:w-5"
                />
                Experience Center
              </span>
            </AnimatedButton>

            <CTAButton variant="secondary" handleClick={handleScroll}>
              See it in action
            </CTAButton>
          </div>
        </div>
      </div>
    </div>
  );
}
